"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Table = _interopRequireDefault(require("../Table.context"));

var _TableRow = _interopRequireDefault(require("../TableRow/TableRow.index"));

var _TableHead = require("./TableHead.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableHead = function TableHead(_ref) {
  var children = _ref.children;
  var context = (0, _react.useContext)(_Table["default"]);
  var type = context.type;
  return /*#__PURE__*/_react["default"].createElement(_TableHead.StyledTableHead, {
    type: type
  }, children);
};

var tableRow = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_TableRow["default"]])
});
TableHead.propTypes = {
  /** TableHead children (react element) should be array of table row type or object of table row type */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(tableRow), tableRow]).isRequired
};
TableHead.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableHead",
  "props": {
    "children": {
      "description": "TableHead children (react element) should be array of table row type or object of table row type",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "tableRow"
          }
        }, {
          "name": "custom",
          "raw": "tableRow"
        }]
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TableHead);

exports["default"] = _default;